export const INITIAL_APP = 'INITIAL_APP'
export const LOADING_LOCAL_STORAGE = 'LOADING_LOCAL_STORAGE'
export const AUTHENTICATE = 'AUTHENTICATE'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const COUNTRIES_BLOCK = 'COUNTRIES_BLOCK'
export const UPDATE_TENANT_SLUG = 'UPDATE_TENANT_SLUG'
export const UPDATE_MUX_KEY = 'UPDATE_MUX_KEY'
export const UPDATE_REGION_SUBCRIPTION = 'UPDATE_REGION_SUBCRIPTION'
